import SpriteSymbol from "../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ic_up_right_arrow",
  "use": "ic_up_right_arrow-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"ic_up_right_arrow\">\n    <polygon id=\"ic_up_right_arrow_path-1\" points=\"9 5 9 7 15.59 7 4 18.59 5.41 20 17 8.41 17 15 19 15 19 5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol